import type { RotasDoModulo } from '@/app/rotas';

import { AccountActivationPage } from './AccountActivationPage';
import { BrokerSelfSignupStartPage } from './BrokerSelfSignupStartPage';
import { BrokerSelfSignupWizardPage } from './BrokerSelfSignupWizardPage';
import { InvitationAcceptPage } from './InvitationAcceptPage';
import { LoginPage } from './LoginPage';
import { PasswordRecoveryPage } from './PasswordRecoveryPage';
import { PasswordResetPage } from './PasswordResetPage';
import { SessionLockedPage } from './SessionLockedPage';

/** Rotas do acesso, todas antes de existir sessao. */
export const rotas: RotasDoModulo = {
  avulsas: [
    // A tela de acesso da empresa, como o /login/:companyDns do OnPoint. A marca so
    // aparece quando a empresa publicou; o identificador vai junto no acesso.
    { path: '/entrar', element: <LoginPage /> },
    { path: '/entrar/:tenantSlug', element: <LoginPage /> },
    {
      path: '/entrar/:tenantSlug/corretor',
      element: <LoginPage variante="corretor" />,
    },

    // Acesso da assessoria (P-ACE-2), como o /login/assessor do OnPoint: a mesma tela
    // de acesso, com o titulo da assessoria. A escolha da corretora vem depois.
    {
      path: '/entrar/:tenantSlug/assessor',
      element: <LoginPage variante="assessor" />,
    },

    // Autocadastro publico da corretora (P-ACE-2): o inicio com a marca da empresa,
    // pela rota ou pelo dominio, e o assistente aberto pelo link do e-mail.
    {
      path: '/entrar/:tenantSlug/cadastro-corretora',
      element: <BrokerSelfSignupStartPage />,
    },
    { path: '/cadastro-corretora', element: <BrokerSelfSignupStartPage /> },
    {
      path: '/cadastro-corretora/:registrationId',
      element: <BrokerSelfSignupWizardPage />,
    },

    // Recuperacao e troca de senha, antes de existir sessao.
    { path: '/recuperar-senha', element: <PasswordRecoveryPage /> },
    { path: '/redefinir-senha/:token', element: <PasswordResetPage /> },

    // Tela de estado publica: sessao bloqueada. A de manutencao e do modulo status.
    { path: '/sessao-bloqueada', element: <SessionLockedPage /> },

    // O aceite de convite acontece antes de existir sessao: quem chega tem o segredo
    // do endereco, e nada mais.
    { path: '/convite/:token', element: <InvitationAcceptPage /> },

    // Ativacao da conta do cadastro publico pelo link do e-mail (ADR 0096). O segredo
    // vem no fragmento (#token=...), que o navegador nao envia a servidor nenhum.
    { path: '/ativar-conta/:activationId', element: <AccountActivationPage /> },
  ],
};
